import React from 'react';
import { View } from 'react-native-web';
import {
  addPathToList,
  Announcement_icon,
  description_upload,
  keyboard_announcement_paragraph,
  keyboard_announcement_sub_title,
  keyboard_announcement_switch_activation,
  keyboard_announcement_switch_privacy_link,
  keyboard_announcement_title,
  keyboard_announcement_WARNING,
  Upload_assets,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import BreakLine from '../components/PanelsComponents/General/BreakLine';
import Title from '../components/PanelsComponents/Text/Title';
import EditTextElement from '../components/PanelsComponents/EditTextElements/EditTextElement';
import UploadMenu from '../components/PanelsComponents/Upload/UploadMenu';
import WarningMessage from '../components/PanelsComponents/Text/WarningMessage';
import { getDefaultGlobJSON } from '../defaultConfigurations/MainConfigurations';

//= ========================================================================
const Panel_V01_announcement = ({
  globJSON,
  selectedScreen,
  onConfigChanged,
  onStepPressed,
  language,
}) => {
  const editTextList = [
    'o_a_title',
    'o_a_privacy_policy',
    'o_a_button_title',
    'maybe_later',
  ];
  const listObject = [
    {
      subHeadline: Announcement_icon,
      fileId: 'configurations/onboarding/announcement/kbd_announcement_icon',
    },
  ];
  const { announcement } = globJSON.configurations.onboarding;
  const announcementDefault = getDefaultGlobJSON().configurations.onboarding.announcement;

  const onValueChanged = (key, value) => {
    announcement[key] = value;
    onConfigChanged();
  };
  const enable_keyboard_activation = announcement.enable_keyboard_activation_flow;
  const { enable_keyboard_privacy_link } = announcement;
  const editTextId = 'privacy_policy_link';
  const onTextChanged = (textId, newText) => {
    announcement[textId] = newText;
    onConfigChanged();
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      selectedScreen={selectedScreen}
      onStepPressed={onStepPressed}
      panelHeadline={keyboard_announcement_title}
      paragraph={keyboard_announcement_paragraph}
      editTextList={addPathToList(editTextList, 'configurations/onboarding/announcement/')}
      tooltipsTitles={globJSON.configurations.onboarding.screens_ordering}
      language={language}
      paragraphMarginBottom={30}
      paddingVertical={25}
      disableEditElements={!enable_keyboard_activation}
    >
      <SwitcherPanel
        text={keyboard_announcement_switch_activation}
        value={enable_keyboard_activation}
        onValueChanged={(value) => {
          onValueChanged('enable_keyboard_activation_flow', value);
        }}
        marginBottom={22}
      />
      {enable_keyboard_activation ? (
        <View>
          <BreakLine />
          <Title isBold>{keyboard_announcement_sub_title}</Title>
          <SwitcherPanel
            text={keyboard_announcement_switch_privacy_link}
            value={enable_keyboard_privacy_link}
            onValueChanged={(value) => {
              onValueChanged('enable_keyboard_privacy_link', value);
            }}
            marginBottom={22}
          />
          {enable_keyboard_privacy_link && (
          <EditTextElement
            editTextId={editTextId}
            editTextValue={announcement[editTextId]}
            editTextDefValue={announcementDefault[editTextId]}
            onTextChanged={(textId, newText) => {
              onTextChanged(textId, newText);
            }}
          />
          )}

          <UploadMenu
            globJSON={globJSON}
            onConfigChanged={onConfigChanged}
            headline={Upload_assets}
            details={description_upload}
            listObject={listObject}
            marginTop={30}
          />
        </View>
      )
        : <WarningMessage>{keyboard_announcement_WARNING}</WarningMessage>}
    </FullPagePanel>
  );
};

export default Panel_V01_announcement;
